import { CssVarsProvider } from "@mui/joy/styles";
import CssBaseline from "@mui/joy/CssBaseline";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import Typography from "@mui/joy/Typography";
import { AddRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import EmployeeSidebar from "../components/EmployeeSidebar";
import EmployeeInvoicesTable from "./EmployeeInvoicesTable";

export default function EmployeeBills({ isPendingPage }: { isPendingPage?: boolean }) {
  const navigate = useNavigate();

  return (
    <CssVarsProvider disableTransitionOnChange>
      <CssBaseline />
      <Box sx={{ display: "flex", minHeight: "92dvh", background: 'white' }}>
        <EmployeeSidebar />
        <Box
          component="main"
          className="MainContent"
          sx={{
            px: { xs: 2, md: 6 },
            pt: {
              xs: "calc(12px + var(--Header-height))",
              sm: "calc(12px + var(--Header-height))",
              md: 3,
            },
            pb: { xs: 2, sm: 2, md: 3 },
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minWidth: 0,
            height: "92dvh",
            gap: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              mb: 1,
              gap: 1,
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "start", sm: "center" },
              flexWrap: "wrap",
              justifyContent: "space-between",
            }}
          >
            <Typography level="h2" component="h1" className="heading-2" sx={{ fontSize: '20px !important' }}>
              {isPendingPage ? "Pending Invoices" : "Invoices"}
            </Typography>
            <Button color="primary" onClick={() => navigate("/employee/add-new-entry")} startDecorator={<AddRounded />} size="sm">
              Add New Entry
            </Button>
          </Box>
          <EmployeeInvoicesTable isPendingPage={isPendingPage} />
        </Box>
      </Box>
    </CssVarsProvider>
  );
}
